// useProfile.ts
import { useAuth0 } from "@auth0/auth0-react";
// import { useApi } from "./useApi.ts";

const API_BASE = process.env.REACT_APP_API_BASE as string;   // Vite 예시

export type Profile = {
  username?: string; phone?: string; department?: string; position?: string;
  timezone?: string; locale?: string;
};

export function useProfile() {
//   const { apiFetch } = useApi();

  const { getAccessTokenSilently } = useAuth0();

  const authFetch = async (input: RequestInfo, init?: RequestInit) => {
    const token = await getAccessTokenSilently();
    return fetch(input, {
      ...init,
      headers: { ...(init?.headers||{}), Authorization: `Bearer ${token}` }
    });
  };

  const load = async (): Promise<Profile> => {
    const res = await authFetch(`${API_BASE}/profile`);
    if (!res.ok) throw new Error("load failed");
    return res.json();
  };

  const save = async (p: Profile) => {
    const res = await authFetch(`${API_BASE}/profile`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(p),
    });
    if (!res.ok) throw new Error("save failed");
  };

  return { load, save };
}
